export default "__VITE_ASSET__BrWXs2D2__"